import moment from 'moment';
import { GeneralSettingsPciStatus } from '@logz-pkg/enums';
class PciModelManipulator {
    isInit = ({ status }) => status === GeneralSettingsPciStatus.Initial;
    isActive = ({ status }) => status === GeneralSettingsPciStatus.Activated;
    isPendingActivation = ({ status }) => status === GeneralSettingsPciStatus.PendingActivation;
    isDeactivated = ({ status }) => status === GeneralSettingsPciStatus.Deactivated;
    isPendingDeactivation = ({ status }) => status === GeneralSettingsPciStatus.PendingDeactivation;
    getFormattedUpdatedAt({ updatedAt }) {
        return moment(updatedAt).format('MMM DD, YYYY');
    }
}
export const pciModelManipulator = new PciModelManipulator();
//# sourceMappingURL=pci.manipulator.js.map